import React, { useEffect, useState } from "react";
// @ts-ignore: allow side-effect CSS import without module declarations
import "./Edit.css";
import { Link } from "react-router-dom";
import { useUser } from "src/shared/context/UserContext";
import { useUserTheme } from "src/shared/hooks/useUserTheme";
type MenuKey = "Edit" | "User" | "Category" | "Product" | "Customer" | "Configuration" | "staff";
interface Props {
  editmenu: Partial<Record<MenuKey, string>> | undefined;
}

interface MenuItem {
  key: MenuKey;
  label: string;
  path: string;
}

interface MenuConfig {
  [businessType: string]: {
    links: MenuItem[];
  };
}

const EditMenu: React.FC<Props> = ({ editmenu }) => {
  const [businessType, setBusinessType] = useState<string>("");
  const { user } = useUser();
  const { bgClass, fontClass, borderHighlight } = useUserTheme();

  const menuConfig: MenuConfig = {
    Laundry: {
      links: [
        { key: "Edit", label: "Branches", path: "/v1/edit/location" },
        { key: "User", label: "Users", path: "/v1/edit/add-agent" },
        { key: "Category", label: "Categories", path: "/v1/edit/add-category" },
        { key: "Product", label: "Products", path: "/v1/edit/add-product" },
        { key: "Customer", label: "Customers", path: "/v1/edit/customer-data" },
      ],
    },
    Carwash: {
      links: [
        { key: "Edit", label: "Branches", path: "/v1/edit/location" },
        { key: "User", label: "Users", path: "/v1/edit/add-agent" },
        { key: "Category", label: "Categories", path: "/v1/edit/add-category" },
        { key: "Product", label: "Products", path: "/v1/edit/add-product" },
        { key: "Customer", label: "Customers", path: "/v1/edit/customer-data" },
      ],
    },
    "Car wash": {
      links: [
        { key: "Edit", label: "Branches", path: "/v1/car-setting/car-branch" },
        { key: "User", label: "Users", path: "/v1/car-setting/car-users" },
        { key: "Category", label: "Categories", path: "/v1/car-setting/car-categorys" },
        { key: "Product", label: "Products", path: "/v1/car-setting/car-products" },
        { key: "Customer", label: "Customers", path: "/v1/car-setting/car-customer" },
      ],
    },
    "Vechicle retailer": {
      links: [
        { key: "Edit", label: "Branches", path: "/v1/setting/vechicle-branch" },
        { key: "User", label: "Users", path: "/v1/setting/vechicle-user" },
        { key: "Category", label: "Categories", path: "/v1/setting/vechicle-category" },
        { key: "Product", label: "Products", path: "/v1/setting/vechicle-product" },
        { key: "Customer", label: "Customers", path: "/v1/setting/vechicle-customer" },
      ],
    },
    Restaurant: {
      links: [
        { key: "Edit", label: "Branches", path: "/v1/edit/location" },
        { key: "User", label: "Users", path: "/v1/edit/add-agent" },
        { key: "Category", label: "Categories", path: "/v1/edit/add-category" },
        { key: "Product", label: "Products", path: "/v1/edit/add-product" },
        { key: "Customer", label: "Customers", path: "/v1/edit/customer-data" },
        // { key: "Configuration", label: "Configurations", path: "/v1/Ressettings/ResConfigurations" },
      ],
    },
    Saloon: {
      links: [
        { key: "Edit", label: "Branches", path: "/v1/saloonedit/style-branch" },
        { key: "User", label: "Users", path: "/v1/saloonedit/style-user" },
        { key: "staff", label: "Staffs", path: "/v1/saloonedit/style-staff" },
        { key: "Category", label: "Categories", path: "/v1/saloonedit/style-category" },
        { key: "Product", label: "Products", path: "/v1/saloonedit/style-product" },
        { key: "Customer", label: "Customers", path: "/v1/saloonedit/style-customer" },
      ],
    },
  };

  useEffect(() => {
    const storedBusinessType = user?.businessType;
    setBusinessType(storedBusinessType || "");
  }, [user?.businessType]);

  if (!businessType || !menuConfig[businessType]) {
    return null;
  }

  return (
    <ul id="edit-menu-list" className={`w-[95%] h-fit bg-white ${borderHighlight} grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 mt-5 rounded-xl -mb-3 gap-2 p-2`}>
      {menuConfig[businessType].links.map(({ key, label, path }) => {
        const isSelected = !!editmenu?.[key];
        return isSelected ? (
          <div key={label} id="menu-item-edit"
            className={`flex items-center justify-center text-xl rounded-lg py-3 px-4 w-full ${fontClass} ${bgClass}`}
            
          >
            {label}
          </div>
        ) : (
          <Link key={label} to={path} id="edit-menu-link"
            className={`flex items-center justify-center text-xl rounded-lg py-3 px-4 w-full transition-colors duration-200 text-[#222] ${fontClass}`}
          >
            {label}
          </Link>
        );
      })}
    </ul>
  );
};

export default EditMenu;
